<div class="modal-header header-info">
    <h4 class="modal-title" >Attached file <span *ngIf="data['modalType'] == 'edit'">edit</span> <span *ngIf="data['modalType'] == 'view'">view</span></h4>
    <span *ngIf="showFile" (click)="attachFileDownload(fileLocation)">
            <i class="fa fa-download attach-download-icon-size" aria-hidden="true"></i>
        </span>
</div>
<div class="modal-body image-bottom" [ngClass]="imageView ?'image-alignment ':''">
    <div class="attach-body-section">
        <!-- initialize form attachedFileEditForm start -->
        <form *ngIf="attachedFileEditForm" class="attch-edit-form" [formGroup]="attachedFileEditForm" (submit)="save()">
            <!-- bind image file name -->
            <div class="">
                <label class="control-label required_field">Name</label>
                <div class="controls">
                    <input type="text" class="control-input test" formControlName="fileName">
                </div>
            </div>
            <!-- show edited tags -->
            <ng-container *ngIf="showTagDropDown">
                <div *access="['TagJobFiles.updateaccess','SetupFileTags.updateaccess']" >
                    <label class="control-label" translate>Tags</label>
                    <div class="file-tag-container select2-file-tags">
                        <input #select2EditFileTags id="editTagList" type="text" csSelect2 (selected)="selectedTag($event)" [placeholder]="'Add tags'"  [select2Config]="tagsSelect2Config" />
                    </div>
                </div>
            </ng-container>

            <div class="" *ngIf="data['modalType'] == 'edit' && showShareOnMobile" style="margin-top: 24px;">
            
                <!-- <input type="checkbox" formControlName="shareOnMobile">
                                                    <span translate>Share on mobile</span> -->
                <div style="margin-bottom:8px">
                    <div class="toggleLable">
                        Mobile access
                    </div>
                    <div class="toggleDescription">
                        Allow engineers to view this file in the mobile app
                    </div>
                </div>
                
                <label class="checkbox-button checkbox-text-center switch">
                    <input type="checkbox" formControlName="shareOnMobile">
                    <span class="slider"></span>
                </label>
                <span class="checkbox-button__label" style="margin-left: 8px;" translate>{{attachedFileEditForm.value.shareOnMobile?
                    "Enabled" : "Disabled"}}</span>
            
            </div>

            <div class="" *ngIf="data['modalType'] == 'edit' && this.data['imageData'].fileVisibilityStatus != 'hide'" style="margin-top: 24px;">
                <div style="margin-bottom:8px">
                    <div class="toggleLable">
                        Customer portal access
                    </div>
                    <div class="toggleDescription">
                        Allow the customer to view this file in the customer portal
                    </div>
                </div>
                <label class="checkbox-button checkbox-text-center switch" [class.disabled-switch]="this.data['imageData'].fileVisibilityStatus == 'disable'">
                    <!-- <input type="checkbox" [disabled]="data['imageData'].createdByPortal" formControlName="shareOnPortal">
                      [style.color]="this.data['imageData'].createdByPortal ? '#90999F'" -->
                    <input type="checkbox" formControlName="shareOnPortal">
                    <span class="slider"></span>
                </label>
                <span class="checkbox-button__label" [style.color]="(this.data['imageData'].fileVisibilityStatus == 'disable') ? '#90999F' : '#505b65'" style="margin-left: 8px; margin-bottom: 8px"
                  translate>{{attachedFileEditForm.getRawValue().shareOnPortal == 1?
                    "Enabled" : "Disabled"}}</span>
                <div *ngIf="this.data['imageData'].fileVisibilityStatus == 'disable'" class="toggle-disabled-description">
                    <div *ngIf="data['imageData'].createdByPortal">
                          This file was added by the customer and therefore customer portal access be disabled
                    </div>
                </div>
            
            </div>

            <!-- show edited image file  -->
            <div class="control-group"  *ngIf="showFile">
                <label class="control-label required_field">
                    <span *ngIf="data['imageData'].filetype == 'PNG' || data['imageData'].filetype == 'png' || data['imageData'].filetype == 'jpg' || data['imageData'].filetype == 'jpeg' || data['imageData'].filetype == 'JPG' || data['imageData'].filetype == 'JPEG'">Image</span>
                    <span *ngIf="data['imageData'].filetype == 'pdf' || data['imageData'].filetype =='PDF'">Pdf</span>
                </label>
                <div class="controls">
                    <div class="image-preview-section" *ngIf="data['imageData'].filetype == 'PNG' || data['imageData'].filetype == 'png' || data['imageData'].filetype == 'jpg' || data['imageData'].filetype == 'jpeg' || data['imageData'].filetype == 'JPG' || data['imageData'].filetype == 'JPEG'">
                        <img alt="attach-image-edit" src="{{fileLocation}}" class="img-responsive img-fluid attach-image-alignment">
                    </div>
                    <div class="image-preview-section" *ngIf="data['imageData'].filetype == 'pdf' || data['imageData'].filetype =='PDF'">
                        <iframe class="pdf-preview-height" width="100%"  height="100%" [src]="fileLocation"></iframe>
                    </div>
                </div>
            </div>
        </form>

        <div class="control-group clearfix" *ngIf="data['modalType'] == 'view'">
            <div class="controls">
                <div class="image-margin" *ngIf="data['imageData'].filetype == 'PNG' || data['imageData'].filetype == 'png' || data['imageData'].filetype == 'jpg' || data['imageData'].filetype == 'jpeg' || data['imageData'].filetype == 'JPG' || data['imageData'].filetype == 'JPEG'">
                    <div class="image-preview-section" >
                        <img alt="attach-image-edit" src="{{fileLocation}}" class="img-responsive img-fluid attach-image-alignment">
                    </div>

                </div>
                <div class="image-preview-section" *ngIf="data['imageData'].filetype == 'pdf' || data['imageData'].filetype =='PDF'">
                    <iframe class="pdf-preview-height" width="100%" height="100%" [src]="fileLocation"></iframe>
                </div>
            </div>
        </div>
        <!-- initialize form attachedFileEditForm end -->
    </div>
</div>
<div class="modal-footer">
    <a class="btn" (click)="onCloseModal()">Cancel</a>
    <button class="btn btn-primary" *ngIf="data['modalType'] == 'edit'" [disabled]="!attachedFileEditForm.valid || action == 'saving' || action != 'save'" (click)="save()">
        <span [hidden]="action == 'saving'"  translate>Save</span>
        <span [hidden]="action != 'saving'" translate>Saving</span>
    </button>
</div>
